import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { DashboardListRow } from '../../../DashboardBirdview'
import { useRentalPortalOverviewLink } from '../RentalPortalOverview.hooks'

import { OverviewCommunicationReadAction } from './OverviewCommunicationReadAction'
import { OverviewCommunicationSubtitle } from './OverviewCommunicationSubtitle'
import {
  checkIsOverviewThreadAddressable,
  getOverviewCommunicationThreadLink,
} from './RentalPortalOverviewCommunicationRow.utils'

import * as styles from './RentalPortalOverviewCommunicationRow.module.css'

function RentalPortalOverviewCommunicationRow({ row }) {
  const isThreadAddressable = checkIsOverviewThreadAddressable(row)

  const {
    handleClickLink: handleClickRead,
    handleMouseDownLink: handleMouseDownRead,
  } = useRentalPortalOverviewLink({
    link: getOverviewCommunicationThreadLink(row.thread_id),
  })

  return (
    <DashboardListRow
      isUnread
      Before={Avatar}
      Meta={OverviewCommunicationReadAction}
      Subtitle={OverviewCommunicationSubtitle}
      beforeProps={{
        className: styles.avatar,
        color: row.sender_color,
        size: AVATAR_HEIGHT_24,
        text: row.sender_display,
      }}
      metaProps={{
        isThreadAddressable,
        onMouseDownRead: handleMouseDownRead,
        onOpenRead: handleClickRead,
      }}
      subtitleProps={{ row }}
      title={row.sender_display}
    />
  )
}

export default RentalPortalOverviewCommunicationRow
